'use client';

import { CacheKey } from '@eliadmin/core/src/api/constants';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { fetchProducts } from '@eliadmin/core/src/api/products/product-api';
import { buildProductsQuery } from '@eliadmin/core/src/utils/product-utils';
import { ProductCard } from '../product/product-card';
import { Spinner } from '@eliadmin/core/src/components/ui/spinner';
import { useState } from 'react';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

export const BrandProductsList = ({
  locale,
  manufacturer_id,
}: {
  locale: string;
  manufacturer_id: number;
}) => {
  const [lastPageX, setLastPageX] = useState(1);
  const { me } = useCustomerStore();

  const productsQueries = buildProductsQuery({
    manufacturers: [manufacturer_id],
    order: 'desc',
    orderBy: 'id',
  });

  const productsQuery = useSuspenseInfiniteQuery({
    initialPageParam: 1,
    queryKey: [manufacturer_id, locale, me?.customer.id ?? null],
    getNextPageParam: (lastPage: any) => {
      if (lastPage?.meta?.current_page < lastPage?.meta?.last_page) {
        return lastPage?.meta?.current_page + 1;
      }
      return undefined;
    },
    queryFn: ({ pageParam }) => {
      return fetchProducts({
        locale,
        authToken: me?.authToken,
        query: {
          ...productsQueries,
          page: pageParam,
          results: 12,
        },
      });
    },
    refetchOnWindowFocus: false,
  });

  const products = productsQuery.data?.pages.flatMap((page: any) => page.data) ?? [];

  const { t } = useTranslations();

  // console.log(productsQuery);

  return (
    <>
      <div
        className={cn(
          'custom-container',
          'grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3',
        )}
      >
        {productsQuery.isSuccess &&
          !productsQuery.isLoading &&
          products.map((product, index) => <ProductCard product={product} key={index} />)}
      </div>

      {productsQuery.hasNextPage && (
        <Button
          onClick={() => productsQuery.fetchNextPage()}
          isLoading={productsQuery.isFetchingNextPage}
          className={cn('mt-16')}
          variant={'outline'}
        >
          {t('text338')}
        </Button>
      )}
    </>
  );
};
